import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
export function TeamPage() {
  const team = [{
    name: 'David Kim',
    title: 'Chief Executive Officer',
    bio: 'David leads the executive team, driving the operational and strategic direction of all JJ Group concepts.',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&q=80'
  }, {
    name: 'Maria Gonzalez',
    title: 'Chief Operations Officer',
    bio: 'Maria ensures flawless execution across our 12 locations, maintaining our high standards of service.',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=800&q=80'
  }, {
    name: 'James Wilson',
    title: 'Executive Chef',
    bio: 'James oversees menu development and culinary training, bringing our Central Asian heritage to life.',
    image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=800&q=80'
  }, {
    name: 'Anita Patel',
    title: 'VP of Marketing',
    bio: 'Anita shapes the brand narrative and drives customer engagement across all our digital and physical touchpoints.',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1bf98c?w=800&q=80'
  }, {
    name: 'Robert Chang',
    title: 'Director of Real Estate',
    bio: 'Robert identifies and secures prime locations for our expanding portfolio of restaurants and event spaces.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&q=80'
  }, {
    name: 'Sophie Laurent',
    title: 'Director of Events',
    bio: 'Sophie curates unforgettable experiences for our private dining and corporate membership clients.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&q=80'
  }];
  return <div className="bg-brand-beige" data-id="element-577">
      <PageHero title="Our Team" subtitle="The passionate individuals behind our exceptional experiences." data-id="element-578" />

      <section className="py-24 md:py-32 relative overflow-hidden" data-id="element-579">
        <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" data-id="element-580"></div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-581">
          <div className="text-center mb-20" data-id="element-582">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-583">
              Leadership Team
            </h2>
            <div className="w-16 h-1 bg-brand-terracotta mx-auto" data-id="element-584"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-585">
            {team.map((member, index) => <motion.div key={index} className="bg-white p-8 rounded-sm shadow-xl shadow-brand-dark/5" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} data-id="element-586">
                <div className="w-32 h-32 rounded-full overflow-hidden mx-auto mb-6 border-4 border-brand-beige" data-id="element-587">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-588" />
                </div>
                <div className="text-center" data-id="element-589">
                  <h3 className="text-2xl font-serif text-brand-dark mb-1" data-id="element-590">
                    {member.name}
                  </h3>
                  <p className="text-brand-terracotta text-xs uppercase tracking-[0.1em] font-medium mb-4" data-id="element-591">
                    {member.title}
                  </p>
                  <p className="text-brand-dark/70 font-light text-sm leading-relaxed" data-id="element-592">
                    {member.bio}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}